import { render, staticRenderFns } from "./NotificationTaskPublish.vue?vue&type=template&id=2ceb445e&scoped=true&lang=pug&"
import script from "./NotificationTaskPublish.vue?vue&type=script&lang=js&"
export * from "./NotificationTaskPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb445e",
  null
  
)

export default component.exports